import { Address } from "../address";
import { TradableWallet } from "./tradable_wallet";

export abstract class AssetWallet extends TradableWallet {
	protected addresses: Address[] = [new Address()];

	public getAddresses(): Address[] {
		return this.addresses;
	}

	public setAddresses(addresses: Address[]): void {
		this.addresses = addresses;
	}
}
